<template>
  <div class="mask_main" v-if="show">
    <div class="mask_content">
      <div class="mask_left">
        <div class="search_box">
          <el-input v-model="value" placeholder="注册代码/单位内编号/使用单位/设备编号" />
          <el-button type="primary" icon="el-icon-search" size="small">搜索</el-button>
        </div>
        <div class="company_box">
          <div
            :class="current == index ? 'company_list active' : 'company_list normal'"
            v-for="(item, index) in companyList"
            :key="index"
            @click="tabsChange(index)"
          >
            <div class="title">武汉东湖高新运营发展有限公司</div>
            <div class="desc">项目名称：<span>软件新城1.1期-1</span></div>
            <div class="desc">单位内编号：<span>A8-B-2</span></div>
            <div class="desc">注册代码：<span>31104201192020010046</span></div>
            <div class="desc">设备编号：<span>13G012808</span></div>
          </div>
        </div>
      </div>
      <div class="mask_right">
        <div class="right_title">
          <div class="title_text">电梯详情</div>
          <img @click="closeMsk" class="close" src="@/assets/image/mask_close.png" />
        </div>
        <div class="detail_label">
          <img class="icon" src="@/assets/image/mask_icon.png" />
          电梯信息
        </div>
        <div class="ele_detail">
          <div class="detail_left">
            <div class="detail_info">注册代码：<span>31104201192020010046</span></div>
            <div class="detail_info">设备编号：<span>13G012808</span></div>
            <div class="detail_info">单位内编号：<span>A8-B-2</span></div>
            <div class="detail_info">
              使用单位：<span>武汉东湖高新运营发展有限公司</span>
            </div>
            <div class="detail_info">项目名称：<span>软件新城1.1期-1</span></div>
            <div class="detail_info">
              定位地址：<span>湖北省武汉市洪山区华山街道双城路113号</span>
            </div>
          </div>
          <img class="detail_photo" src="@/assets/zhuapai2.png" />
        </div>
        <div class="detail_label">
          <img class="icon" src="@/assets/image/mask_icon.png" />
          近7天告警
        </div>
        <div class="detail_table">
          <el-table class="tableSpec" :data="tableData">
            <el-table-column
              label="告警名称"
              prop="name"
              align="center"
            ></el-table-column>
            <el-table-column label="告警状态" prop="name" align="center">
              <template slot-scope="scope">
                <div :class="scope.row.aaa ? 'warn_type' : 'warn_type'">已解除</div>
              </template>
            </el-table-column>
            <el-table-column
              label="告警时间"
              prop="name"
              align="center"
            ></el-table-column>
            <el-table-column
              label="解除时间"
              prop="name"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10]"
            :page-size="10"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
export default {
  name: "TheMask",
  data() {
    return {
      value: "",
      show: false,
      current: 0,
      companyList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      tableData: [{ name: "asd阿萨德e" }],
      total: 23,
    };
  },

  mounted() {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    tabsChange(index) {
      this.current = index;
    },
    closeMsk() {
      this.show = false;
    },
    open() {
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.mask_main {
  position: fixed;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 20, 38, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  .mask_content {
    width: 1200px;
    height: 738px;
    background: rgba(0, 30, 58, 0.72);
    box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
    border: 2px solid rgba(103, 192, 255, 0.46);
    padding: 0 0 20px 20px;
    display: flex;
    justify-content: space-between;
    .mask_left {
      width: 400px;
      display: flex;
      flex-direction: column;
      height: 718px;
      padding-top: 20px;
      .search_box {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 20px;
      }
      .company_box {
        height: calc(100% - 56px);
        width: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none; /* 隐藏滚动条 */
        }
        // /* 整个滚动条 */
        // &::-webkit-scrollbar {
        //   width: 8px; /* 垂直滚动条宽度 */
        //   height: 8px; /* 水平滚动条高度 */
        // }

        // /* 滚动条轨道 */
        // &::-webkit-scrollbar-track {
        //   background: #f0f0f0; /* 滚动条轨道背景色 */
        //   border-radius: 4px;
        // }

        // /* 滚动条滑块 */
        // &::-webkit-scrollbar-thumb {
        //   background-color: #999; /* 滑块颜色 */
        //   border-radius: 4px;
        // }

        // /* 滑块悬停状态 */
        // &::-webkit-scrollbar-thumb:hover {
        //   background-color: #666;
        // }
        .company_list:last-of-type {
          /* 作用于最后一个同类型元素 */
          margin-bottom: 0;
        }
        .company_list {
          width: calc(100%);
          height: 156px;
          box-sizing: border-box;
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          padding-left: 20px;
          &.active {
            background: url("@/assets/image/c_bg.png") no-repeat center;
            background-size: 100% 100%;
          }
          &.normal {
            border: 1px solid;
            border-image: linear-gradient(
                137deg,
                rgba(
                  32.439159527421,
                  130.02996504306793,
                  209.4642922282219,
                  0.6399999856948853
                ),
                rgba(72.31312930583954, 108.52400064468384, 147.23214358091354, 1)
              )
              1 1;
          }
          .title {
            font-weight: 700;
            font-size: 18px;
            color: #fff;
          }
          .desc {
            font-weight: 400;
            font-size: 16px;
            color: #b8c6d3;
            span {
              color: #fff;
            }
          }
        }
      }
    }
    .mask_right {
      width: 760px;
      height: 100%;
      .right_title {
        background: url("@/assets/image/mask_title.png") no-repeat center;
        background-size: 100% 100%;
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title_text {
          font-family: YouSheBiaoTiHei;
          font-weight: 400;
          font-size: 24px;
          background: linear-gradient(90deg, #ffffff 0%, #4caeff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-left: 50px;
        }
        .close {
          width: 26px;
          height: 26px;
          margin-right: 20px;
        }
      }
      .detail_label {
        height: 24px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #58baff;
        margin: 19px auto 10px;
        .icon {
          width: 12px;
          height: 12px;
          margin-right: 6px;
        }
      }
      .ele_detail {
        width: 660px;
        height: 176px;
        background: rgba(0, 30, 58, 0.72);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border: 1px solid rgba(103, 192, 255, 0.46);
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px 40px;
        .detail_left {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          .detail_info {
            font-weight: 400;
            font-size: 16px;
            color: #b8c6d3;
            span {
              color: #fff;
            }
          }
        }
        .detail_photo {
          width: 200px;
          height: 150px;
        }
      }
      .detail_table {
        width: 700px;
        height: 263px;
        background: rgba(0, 30, 58, 0.72);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border: 1px solid rgba(103, 192, 255, 0.46);
        padding: 20px;
        .tableSpec {
          width: 700px;
          height: 100%;
        }
      }
      .page_box {
        height: 70px;
        width: 740px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
::v-deep .search_box .el-input {
  border-radius: 4px;
  height: 36px !important;
  width: 280px !important;
  .el-input__inner {
    height: 36px !important;
    width: 280px !important;
    color: #fff;
    background: linear-gradient(
      134deg,
      rgba(0, 212, 255, 0.13) 0%,
      rgba(80, 176, 255, 0) 100%
    );
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #4dbbff;
  }
}

::v-deep .search_box .el-button {
  width: 80px;
  height: 36px;
  background: #24abff;
  border-radius: 4px;
  margin-left: 20px;
}

::v-deep .search_box .el-input__inner::placeholder {
  font-weight: 400;
  font-size: 13px;
  color: #93e4ff;
}
/* 谷歌 */
::v-deep .search_box .el-input__inner::-webkit-input-placeholder {
  font-weight: 400;
  font-size: 13px;
  color: #93e4ff;
}
/* 火狐 */
::v-deep .search_box .el-input__inner:-moz-placeholder {
  font-weight: 400;
  font-size: 13px;
  color: #93e4ff;
}
/*ie*/
::v-deep .search_box .el-input__inner:-ms-input-placeholder {
  font-weight: 400;
  font-size: 13px;
  color: #93e4ff;
}

.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
:deep(.el-table) {
  background-color: transparent;
}
:deep(.el-table__expanded-cell) {
  background-color: transparent;
}
:deep(.el-table th) {
  // background-color: rgba(0, 238, 246, 0.08) !important;
  color: #00ffff;
  border-top: 1px solid #58bfff;
  background-color: transparent !important;
  // font-size: 0.06rem;
}
:deep(.el-table tr) {
  background-color: transparent !important;
  color: #ffffff;
}
:deep(.el-table td) {
  background-color: transparent !important;
}
.el-table__fixed::before {
  background-color: transparent;
}

::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff !important;
}
// 去除table表格底部白色线条
::v-deep .el-table::before {
  background-color: transparent !important;
}
::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}

::v-deep .el-pagination__total {
  font-weight: 400;
  font-size: 16px;
  color: #fff;
}

::v-deep .page_box .el-input {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__inner {
    height: 30px;
    border-radius: 2px;
    border: 1px solid #fff;
    background: transparent !important;
  }
}
.warn_type {
  width: 62px;
  height: 24px;
  background: url("@/assets/image/success_icon.png") no-repeat center;
  background-size: 100% 100%;
  margin: auto;
  text-align: center;
  line-height: 24px;
}

::v-deep .el-pagination__total {
  font-weight: 400;
  font-size: 16px;
  color: #fff;
}

::v-deep .page_box .el-input {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__inner {
    height: 30px;
    border-radius: 2px;
    border: 1px solid #fff;
    background: transparent !important;
  }
}

/* 谷歌 */
::v-deep .page_box .el-input__inner {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
}
::v-deep .btn-prev {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .btn-next {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-pager .number {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
  &.active {
    background: #0f77af !important;
  }
}
::v-deep .el-pagination__jump {
  color: #fff !important;
}
</style>
